import React from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import Paper from "@material-ui/core/Paper";
import history from "../../Routes/history";
import { Add as AddIcon, CheckCircle as OkIcon } from "@material-ui/icons";
import { numberToFormat } from "../../Utils";

class FactureReaData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { is26Percent, dateFac, bdcValue, datecomptable, handleChange, sortedFac, mo, dossier, devisrea, totalht } = this.props;

    return (
      <div className="facture-readata">
        <TableContainer className="table-data" component={Paper}>
          <Table aria-label="simple table">
            <TableHead className="table-head">
              <TableRow className="head-row">
                <TableCell className="MuiTableCell-head" colSpan={2}>
                  Données de Réalisation
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Réference:</TableCell>
                <TableCell>
                  <Typography>{dossier.operation}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Code Client:</TableCell>
                <TableCell>
                  <Typography name="codeclient">{sortedFac.numclient}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>N° de Facture:</TableCell>
                <TableCell>
                  <Typography name="numfacture">{sortedFac.new_nfac}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Nom de l'entreprise:</TableCell>
                <TableCell>
                  <Typography name="nomentreprise">{dossier.sci_sccv}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Nom du responsable:</TableCell>
                <TableCell>
                  <Typography name="nomresponsable">{mo.prenom + " " + mo.nom}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Adresse:</TableCell>
                <TableCell>
                  <Typography name="adresse">{dossier.adresse_op}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Code Postal:</TableCell>
                <TableCell>
                  <Typography name="codepostal">{dossier.cp_op}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Ville:</TableCell>
                <TableCell>
                  <Typography name="ville">{dossier.ville_op}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Adresse Mail:</TableCell>
                <TableCell>
                  <Typography name="adressemail">{mo.mail}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Date de Facture:</TableCell>
                <TableCell>
                  <input
                    type="date"
                    name="datefacture"
                    style={{ marginLeft: "0" }}
                    value={dateFac || ''}
                    onChange={(event) => handleChange(event)}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Date d'établissement:</TableCell>
                <TableCell>
                  <input
                    type="date"
                    name="datecomptable"
                    style={{ marginLeft: "0" }}
                    value={datecomptable || ''}
                    onChange={(event) => handleChange(event)}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>N° BDC:</TableCell>
                <TableCell>
                  <input
                    type="text"
                    name="bdcValue"
                    value={bdcValue}
                    placeholder="&quot;Bon de commande&quot;"
                    onChange={(event) => handleChange(event)}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Montant HT:</TableCell>
                <TableCell>
                  <Typography name="montantht">{totalht ? numberToFormat(totalht) + ' €' : ''}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Montant TTC:</TableCell>
                <TableCell>
                  <Typography name="montantht">{totalht ? numberToFormat(totalht * 1.2) + ' €' : ''}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Button
            className="create-btn"
            variant="contained"
            color="primary"
            startIcon={!devisrea ? <OkIcon /> : <AddIcon />}
            onClick={() => {
              if (!devisrea) {
                history.push("/devis/validation");
              } else this.props.handleOpenCreate()
            }}>
            {!devisrea ? 'Valider le devis' : 'Créer nouvelle facture'}
          </Button>
        </TableContainer>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  facture: state.facture.items,
  nfacvalue: state.facture.nfacvalue,
  dossierValue: state.devis.dossierValue,
  itemNdossier: state.echeances.itemNdossier
});
export default connect(mapStateToProps)(FactureReaData);